import { useTranslation } from 'react-i18next';

/**
 * DC-13 durations. Seconds read badly past a minute and minutes read badly past an
 * hour, so the unit follows the magnitude. Callers pass a magnitude — the sign is
 * theirs to word, since "saved" and "took longer" are different sentences.
 */
export function useDuration() {
  const { t } = useTranslation();

  const fromMinutes = (minutes: number) => {
    if (minutes < 60) return t('common.duration.minutes', { count: minutes });

    const hours = Math.floor(minutes / 60);
    const remainder = minutes % 60;
    return remainder === 0
      ? t('common.duration.hours', { count: hours })
      : t('common.duration.hoursMinutes', { hours, minutes: remainder });
  };

  const fromSeconds = (seconds: number) =>
    seconds < 60 ? t('common.duration.seconds', { count: seconds }) : fromMinutes(Math.round(seconds / 60));

  return { fromSeconds, fromMinutes };
}
